import React, { Component } from 'react';

import { Link } from 'react-router-dom';
import EmailIcon from '@material-ui/icons/Email';
import logo1 from '../assets/images/Capture.PNG';

class Thankyou extends Component {
    render() {
        return (
            <div>
                
                <div className="site-section"> 
    <div className="container">
        <div className="row">
            <div className="col-md-12 text-center">
                <span className="icon-check_circle display-3 text-success"></span>
                
                <h2 className="display-3 text-black">شكرًا لك!</h2>
                
                <p className="lead">
                    شكرًا لزيارتك <strong>محل للدهانات بويه – الرياض، السعودية</strong>. <br />
                    سيتم إرسال رسالة إلى بريدك الإلكتروني قريبًا.
                </p>
                
                <center>
                    <img src={logo1} alt="" />
                </center> 

                <p className="lead mb-2">تم إكمال طلبك بنجاح</p>

                <p className="lead mb-2">
                    <EmailIcon/> تم إرسال إيصال الطلب، متضمنًا جميع التفاصيل، <br />
                    إلى البريد الإلكتروني الذي قمت بإدخاله. يرجى الاحتفاظ به للرجوع إليه لاحقًا.
                </p>

                <p>
                    <Link to='/'>
                        <div className="btn btn-sm btn-primary">العودة إلى المتجر</div>
                    </Link>
                </p>
            </div>
        </div>
    </div>
</div>


            </div>
        )
    }
}

export default Thankyou;